import React, { Component } from "react";
import { Menu } from "semantic-ui-react";

import { SearcherContext } from "../../shared/search/components/SearcherContext";

class PageMenu extends Component {
  static contextType = SearcherContext;
  state = {};
  handleItemClick = (e, { name }) => this.setState({ activeItem: name });

  render() {
    const { activeItem } = this.state;
    return (
      <Menu stackable compact size="mini" borderless className="nav-buttons">
        <Menu.Item
          icon="home"
          name="home"
          active={activeItem === "home"}
          onClick={event =>
            this.props.history.push(
              `${process.env.REACT_APP_URL_PATH}`
            )
          }
        />

        <Menu.Item
          name="about"
          active={activeItem === "about"}
          onClick={event =>
            this.props.history.push(
              `${process.env.REACT_APP_URL_PATH}/about`
            )
          }
        />
        <Menu.Item
          name="help"
          icon="help circle"
          active={activeItem === "help"}
          onClick={event =>
            this.props.history.push(
              `${process.env.REACT_APP_URL_PATH}/help/start`
            )
          }
        />
      </Menu>
    );
  }
}

export default PageMenu;
